// property-assignment Component (tab rename)
// import { activateNewTab } from './property-assignment.js';

export default (groupName = '') => ({
    editing: false,
    name: groupName,

    init() {
    },

    startEditing() {
        this.editing = true;
        this.$nextTick(() => this.$refs.input.focus());
    },

    cancelEditing() {
        this.editing = false;
        this.name = this.$refs.input.getAttribute('data-original');
    },

    confirmEditing() {
        const oldName = this.$refs.input.getAttribute('data-original');
        this.editing = false;
        this.$dispatch('rename-group', { oldName, newName: this.name });
        this.$refs.input.setAttribute('data-original', this.name);
    },
});

